<template>
  <div class="terms-container">
    <div class="terms-header">
      <h1 class="terms-title">Terms of Service for aKinder™Volunteer</h1>
      <p class="terms-subtitle">
        Type of Applications website: Volunteering website
      </p>
      <p class="terms-subtitle">Effective date: 1st day of January, 2025</p>
    </div>

    <div class="terms-content">
      <div class="terms-intro">
        <p>
          aKinder™Volunteer (the "Site") is owned and operated by
          aKinder™Company and offers a limited licensed to Legacy Response for
          use within their nonprofit mission of building community. aKINDer
          Company can be reached at:
        </p>
        <ul class="contact-list">
          <li><span>Email: dblais@akindercompany.com</span></li>
          <li><span>Phone: (508) 202-3165</span></li>
          <li>
            <span
              >Address: 399 Boylston Street, 6th Floor, Boston, MA 02116</span
            >
          </li>
        </ul>
      </div>

      <div
        v-for="(section, index) in sections"
        :key="index"
        class="terms-section"
      >
        <h2 class="section-title">{{ section.title }}</h2>
        <div class="section-content" v-html="section.content"></div>

        <div v-if="section.subsections" class="subsections">
          <div
            v-for="(subsection, subIndex) in section.subsections"
            :key="subIndex"
            class="subsection"
          >
            <p class="subsection-content">
              <span class="subsection-title">{{ subsection.title }}</span>
              {{ subsection.content }}
            </p>
          </div>
        </div>
      </div>

      <div class="terms-contact">
        <h2 class="section-title">12. Contact</h2>
        <p>
          For any questions regarding these terms, please contact our privacy
          officer, David Blais, at:
        </p>
        <div class="contact-info">
          <p>dblais@akindercompany.com</p>
          <p>(508) 202-3165</p>
          <p>399 Boylston Street, 6th Floor, Boston, MA 02116</p>
        </div>
      </div>

      <div class="terms-footer">
        <p>
          © {{ new Date().getFullYear() }} aKinder™Company. All rights reserved.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsOfService",
  data() {
    return {
      sections: [
        {
          title: "1. Acceptance of Terms",
          content:
            "By accessing and using the aKinder™Volunteer website and services, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to abide by these terms, please do not use this service."
        },
        {
          title: "2. Description of Service",
          content:
            "aKinder™Volunteer serves as a platform that connects volunteers seeking opportunities to help others with agencies providing those opportunities. The platform enables users to publish events, chat, track volunteer hours, and connect with other users."
        },
        {
          title: "3. User Responsibilities",
          content:
            "Users are responsible for all activity on their account and for ensuring the content they post is accurate, truthful, and not misleading. Users agree not to use the platform to post content that is unlawful, libelous, abusive, obscene, discriminatory, false, or misleading."
        },
        {
          title: "4. Content Ownership and Rights",
          content:
            "While all content posted by users remains the sole property of the user who posted it, by sharing it on aKinder™Volunteer, users grant the platform a non-exclusive, royalty-free, transferable, sublicensable, worldwide license to host, use, distribute, modify, run, copy, publicly display and produce derivative works of their content."
        },
        {
          title: "5. Social Media and Third-party Platforms",
          content:
            'aKinder™Volunteer allows users to link or integrate their accounts with certain third-party social media and other platforms, including but not limited to Facebook, Instagram, LinkedIn, Twitter, and TikTok ("Third-party Platforms").',
          subsections: [
            {
              title: "a. Integration: ",
              content:
                "If users choose to link or integrate aKinder™Volunteer with Third-party Platforms, they understand that they are granting aKinder™Volunteer access to retrieve and use information, content, and other data from these Third-party Platforms as permitted by these platforms."
            },
            {
              title: "b. Authorization: ",
              content:
                "Users must ensure they have the right to share any content or data from Third-party Platforms with aKinder™Volunteer. Users are solely responsible for ensuring that their use of aKinder™Volunteer in conjunction with any Third-party Platforms complies with all agreements, terms, and conditions between the user and such Third-party Platforms."
            },
            {
              title: "c. Disclaimers: ",
              content:
                "aKinder™Volunteer is not endorsed, sponsored, affiliated with, or otherwise authorized by any Third-party Platforms. All logos, trademarks, and other proprietary rights of the Third-party Platforms are the property of their respective owners."
            },
            {
              title: "d. Limitation: ",
              content:
                "aKinder™Volunteer is not liable for any actions, content, or behaviors of the Third-party Platforms. Users agree to release aKinder™Volunteer from any claims, damages, liabilities, arising out of or in connection with their use or interaction with any Third-party Platforms."
            }
          ]
        },
        {
          title: "6. Data Handling and Privacy",
          content:
            "Users' privacy is essential. All personal data and information provided to aKinder™Volunteer are governed by our Privacy Policy, which is incorporated into these terms by reference."
        },
        {
          title: "7. Termination",
          content:
            "aKinder™Volunteer reserves the right to terminate any user account if they are found to be in violation of our terms, engage in fraudulent behavior, or any other serious misconduct."
        },
        {
          title: "8. Disclaimers",
          content:
            'aKinder™Volunteer is provided "as-is" and without any warranties of any kind, either express or implied. We do not guarantee that the platform will function without interruptions or errors.'
        },
        {
          title: "9. Limitation of Liability",
          content:
            "aKinder™Volunteer, nor its affiliates, will be liable for any indirect, incidental, special, consequential, or punitive damages, whether under a contract, tort, or any other theory of liability, even if aKinder™Volunteer is aware of the possibility of such damages."
        },
        {
          title: "10. Modifications to Terms of Service",
          content:
            "We reserve the right to modify these terms at any time. Changes will become effective immediately upon their posting on the platform. Continued use of the platform signifies your acceptance of these changes."
        },
        {
          title: "11. Governing Law and Dispute Resolution",
          content:
            "These terms shall be governed by and construed in accordance with the laws of the State of Massachusetts, United States. Any disputes arising will first be attempted to be resolved through mediation before resorting to litigation in the courts of the State of Massachusetts, United States."
        }
      ]
    };
  }
};
</script>

<style scoped>
:root {
  --primary-color: #4a90e2;
  --secondary-color: #5cb85c;
  --accent-color: #f8f9fa;
  --text-color: #333;
  --border-color: #e0e0e0;
}

.terms-container {
  max-width: 1000px;
  margin: 0 auto;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: var(--text-color);
  padding: 20px;
}

.terms-header {
  text-align: center;
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, #4a90e2, #5cb85c);
  color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.terms-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.terms-subtitle {
  font-size: 1.1rem;
  opacity: 0.9;
  margin: 0.25rem 0;
}

.terms-content {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 2rem;
}

.terms-intro {
  margin-bottom: 2rem;
  font-size: 1rem;
}

.contact-list {
  list-style-type: none;
  padding: 1rem;
  margin: 1rem 0;
  background-color: #f8f9fa;
  border-radius: 6px;
}

.contact-list li {
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
}

.contact-list li::before {
  content: "•";
  color: var(--primary-color);
  font-weight: bold;
  margin-right: 0.75rem;
}

.terms-section {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--border-color);
}

.section-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #2c3e50;
}

.section-content {
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.subsections {
  margin-top: 1rem;
}

.subsection {
  padding-left: 1.5rem;
  margin-bottom: 0.75rem;
}

.subsection-title {
  font-weight: 600;
  color: #2c3e50;
}

.terms-contact {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.contact-info {
  padding: 1.5rem;
  background-color: #f0f7ff;
  border-radius: 6px;
  margin-top: 1rem;
  line-height: 1.8;
}

.terms-footer {
  text-align: center;
  margin-top: 3rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-color);
  font-size: 0.9rem;
  color: #6c757d;
}

@media (max-width: 768px) {
  .terms-container {
    padding: 10px;
  }

  .terms-header {
    padding: 1.5rem 1rem;
  }

  .terms-title {
    font-size: 1.5rem;
  }

  .terms-content {
    padding: 1.5rem;
  }

  .section-title {
    font-size: 1.1rem;
  }

  .subsection {
    padding-left: 1rem;
  }
}

@media (max-width: 480px) {
  .terms-header {
    padding: 1.2rem 0.8rem;
  }

  .terms-title {
    font-size: 1.3rem;
  }

  .terms-content {
    padding: 1rem;
  }

  .section-title {
    font-size: 1rem;
  }

  .subsection {
    padding-left: 0.75rem;
  }
}
</style>
